import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'guaraniFormat'
})
export class GuaraniFormatPipe implements PipeTransform {
  transform(value: number | null): string {
    if (value == null) {
      return 'Gs. 0';
    }
    // Formata o número sem casas decimais e com pontos separando os milhares
    return `Gs. ${value.toLocaleString('es-PY', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true
    })}`;
  }
}
